module.exports = __webpack_public_path__ + "static/media/mainimg-05.15cc18c3.png";